import { useEffect, useState } from "react";
import "../styles/intro.css";

export default function IntroScreen({ onFinish }) {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const timer1 = setTimeout(() => setHide(true), 1800);
    const timer2 = setTimeout(() => onFinish(), 2600);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [onFinish]);

  return (
    <div className={`intro-screen ${hide ? "intro-hide" : ""}`}>
        <div className="intro-wave-wrap">
        <svg
          className="intro-wave"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path
            fill="#0d3b66"
            fillOpacity="0.18"
            d="M0,224L60,208C120,192,240,160,360,144C480,128,600,128,720,149.3C840,171,960,213,1080,229.3C1200,245,1320,235,1380,229.3L1440,224L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
          />
        </svg>
      </div>
      <div className="intro-content">
        <h1>FOREMAN SHIPBUILDING OY</h1>
        <p>Built on precision. Driven by trust</p>
      </div>
    </div>
  );
}